module.exports = __webpack_public_path__ + "static/media/Russell Road Kitchen (3).f458dc8d.jpg";